import httpClient from "utils/http-client";
import { API_MFA_GET } from "consts";

function bearerConfig(accessToken) {
  return accessToken != null && accessToken !== ""
    ? { headers: { Authorization: `Bearer ${accessToken}` } }
    : {};
}

/**
 * POST helper that attaches a Bearer token when present (temp session JWT).
 * @param {string} url
 * @param {object} body
 * @param {string} [accessToken]
 */
export function postWithBearer(url, body, accessToken) {
  return httpClient.post(url, body, bearerConfig(accessToken));
}

/**
 * GET helper with Bearer token (temp session JWT).
 * @param {string} url
 * @param {string} accessToken
 */
export function getWithBearer(url, accessToken) {
  return httpClient.get(url, bearerConfig(accessToken));
}

/**
 * @param {string} accessToken
 * @returns {Promise<{ mfaEnabled: boolean, mfaMode: number }>}
 */
export function getMfaSettings(accessToken) {
  return getWithBearer(API_MFA_GET, accessToken);
}
